import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState('all');
  const [form, setForm] = useState({
    name: '', phone: '', id_number: '', address: '', customer_type: 'regular'
  });
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/customers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(response.data.customers);
    } catch (err) { console.error(err); }
  };

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `https://app.hayahost.net/api/customers/search?query=${search}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCustomers(response.data.customers);
    } catch (err) { console.error(err); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/customers', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setShowForm(false);
      setForm({ name: '', phone: '', id_number: '', address: '', customer_type: 'regular' });
      fetchCustomers();
      alert('تم إضافة العميل بنجاح!');
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const getTypeBadge = (type) => {
    switch(type) {
      case 'company': return { text: '🏢 شركة', bg: '#e3f2fd', color: '#1a237e' };
      default: return { text: '👤 عادي', bg: '#e8f5e9', color: '#2e7d32' };
    }
  };

  const filteredCustomers = filterType === 'all' 
    ? customers 
    : customers.filter(c => c.customer_type === filterType);

  const totalRegular = customers.filter(c => c.customer_type === 'regular').length;
  const totalCompany = customers.filter(c => c.customer_type === 'company').length;

  return (
    <div style={styles.container}>
      <div style={styles.navbar}>
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar}>
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
        </div>

        <div style={styles.content}>

          {/* إحصائيات */}
          <div style={styles.statsGrid}>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}}>
              <div style={styles.statIcon}>👥</div>
              <div style={styles.statNumber}>{customers.length}</div>
              <div style={styles.statLabel}>إجمالي العملاء</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}}>
              <div style={styles.statIcon}>👤</div>
              <div style={styles.statNumber}>{totalRegular}</div>
              <div style={styles.statLabel}>عملاء عاديين</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #e65100, #f57c00)'}}>
              <div style={styles.statIcon}>🏢</div>
              <div style={styles.statNumber}>{totalCompany}</div>
              <div style={styles.statLabel}>شركات</div>
            </div>
          </div>

          <div style={styles.header}>
            <h2 style={styles.pageTitle}>👥 إدارة العملاء والشركات</h2>
            <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
              {showForm ? 'إلغاء' : '+ إضافة عميل / شركة'}
            </button>
          </div>

          {showForm && (
            <div style={styles.formCard}>
              <h3 style={styles.formTitle}>إضافة عميل / شركة جديدة</h3>
              <form onSubmit={handleSubmit}>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>الاسم الكامل *</label>
                    <input style={styles.input} value={form.name}
                      onChange={e => setForm({...form, name: e.target.value})}
                      placeholder="أدخل الاسم" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>رقم الهاتف *</label>
                    <input style={styles.input} value={form.phone}
                      onChange={e => setForm({...form, phone: e.target.value})}
                      placeholder="07XXXXXXXXX" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>رقم الهوية / السجل التجاري</label>
                    <input style={styles.input} value={form.id_number}
                      onChange={e => setForm({...form, id_number: e.target.value})}
                      placeholder="رقم الهوية أو السجل التجاري" />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>نوع العميل</label>
                    <select style={styles.input} value={form.customer_type}
                      onChange={e => setForm({...form, customer_type: e.target.value})}>
                      <option value="regular">👤 عادي</option>
                      <option value="company">🏢 شركة</option>
                    </select>
                  </div>
                  <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                    <label style={styles.label}>العنوان</label>
                    <input style={styles.input} value={form.address}
                      onChange={e => setForm({...form, address: e.target.value})}
                      placeholder="المدينة - المنطقة" />
                  </div>
                </div>
                <button style={styles.submitBtn} type="submit" disabled={loading}>
                  {loading ? 'جاري الحفظ...' : '💾 حفظ'}
                </button>
              </form>
            </div>
          )}

          {/* البحث والفلتر */}
          <div style={styles.searchBar}>
            <input style={styles.searchInput} value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="🔍 بحث بالاسم أو رقم الهاتف..."
              onKeyPress={e => e.key === 'Enter' && handleSearch()} />
            <button style={styles.searchBtn} onClick={handleSearch}>بحث</button>
            <button style={styles.resetBtn} onClick={() => { setSearch(''); fetchCustomers(); }}>إعادة</button>
          </div>

          {/* فلتر النوع */}
          <div style={styles.filterRow}>
            {['all', 'regular', 'company'].map(type => (
              <button key={type}
                style={filterType === type ? styles.filterActive : styles.filterBtn}
                onClick={() => setFilterType(type)}>
                {type === 'all' ? 'الكل' : type === 'regular' ? '👤 عادي' : '🏢 شركة'}
              </button>
            ))}
          </div>

          {/* جدول العملاء */}
          <div style={styles.tableCard}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHead}>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>الاسم</th>
                  <th style={styles.th}>رقم الهاتف</th>
                  <th style={styles.th}>رقم الهوية / السجل</th>
                  <th style={styles.th}>النوع</th>
                  <th style={styles.th}>العنوان</th>
                  <th style={styles.th}>تاريخ التسجيل</th>
                </tr>
              </thead>
              <tbody>
                {filteredCustomers.map((c, i) => {
                  const badge = getTypeBadge(c.customer_type);
                  return (
                    <tr key={c.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                      <td style={styles.td}>{i + 1}</td>
                      <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{c.name}</td>
                      <td style={styles.td}>{c.phone}</td>
                      <td style={styles.td}>{c.id_number || '-'}</td>
                      <td style={styles.td}>
                        <span style={{...styles.badge, background: badge.bg, color: badge.color}}>
                          {badge.text}
                        </span>
                      </td>
                      <td style={styles.td}>{c.address || '-'}</td>
                      <td style={styles.td}>{new Date(c.created_at).toLocaleDateString('ar-IQ')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {filteredCustomers.length === 0 && (
              <div style={styles.empty}>لا يوجد عملاء</div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0' },
  content: { flex: 1, padding: '30px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', marginBottom: '25px' },
  statCard: { borderRadius: '12px', padding: '20px', color: 'white', textAlign: 'center' },
  statIcon: { fontSize: '28px', marginBottom: '8px' },
  statNumber: { fontSize: '28px', fontWeight: 'bold', marginBottom: '5px' },
  statLabel: { fontSize: '12px', opacity: 0.9 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px' },
  addBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  formTitle: { marginBottom: '20px', color: '#1a237e' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: {},
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  submitBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  searchBar: { display: 'flex', gap: '10px', marginBottom: '15px' },
  searchInput: { flex: 1, padding: '10px 15px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  searchBtn: { background: '#1a237e', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' },
  resetBtn: { background: '#666', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' },
  filterRow: { display: 'flex', gap: '8px', marginBottom: '15px' },
  filterBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '6px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  filterActive: { background: '#1a237e', color: 'white', border: 'none', padding: '6px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'right', fontSize: '13px' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '10px 15px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  badge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
};

export default Customers;